import React from "react";
import cx from "classnames";
import styles from "./Footer.module.scss";

import Logo from "assets/img/grind-logo.svg";

import FooterVisa from "assets/icons/footer-visa.svg";
import FooterMastercard from "assets/icons/footer-mastercard.svg";
import FooterAmex from "assets/icons/footer-amex.svg";
import FooterApplePay from "assets/icons/footer-apple-pay.svg";
import FooterPaypalPay from "assets/icons/footer-paypal-pay.svg";

import Instagram from "assets/icons/instagram.svg";
import Twitter from "assets/icons/twitter.svg";
import Facebook from "assets/icons/facebook.svg";
import Spotify from "assets/icons/spotify.svg";

const socialLinks = [
    {
        link: "https://www.instagram.com/grind/",
        icon: Instagram,
        alt: "Instagram",
    },
    {
        link: "https://twitter.com/grind",
        icon: Twitter,
        alt: "Twitter",
    },
    {
        link: "https://facebook.com/grind",
        icon: Facebook,
        alt: "Facebook",
    },
    {
        link: "https://open.spotify.com/user/grindstudio",
        icon: Spotify,
        alt: "Spotify",
    },
];

const paymentOptions = [
    {
        img: FooterAmex,
        alt: "Amex",
    },
    {
        img: FooterApplePay,
        alt: "Apple Pay",
    },
    {
        img: FooterVisa,
        alt: "Visa",
    },
    {
        img: FooterMastercard,
        alt: "Mastercard",
    },
    {
        img: FooterPaypalPay,
        alt: "Paypal",
    },
];

const Footer = () => {
    return (
        <footer className={cx(styles.footer, "footer")}>
            <div className={styles.container}>
                <div className={styles.logo}>
                    <img width="149" height="30" alt="Grind logo" src={Logo} />
                </div>
                <div className={styles.columns}>
                    <div>
                        <h3 className={styles.followus}>Follow us.</h3>
                        <p>
                            {socialLinks.map((socialLink, idx) => (
                                <a
                                    href={socialLink.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={styles.socialLink}
                                    key={idx}
                                >
                                    <img
                                        src={socialLink.icon}
                                        alt={socialLink.alt}
                                    />
                                </a>
                            ))}
                        </p>

                        <h3 className={cx(styles.heading)}>Find us.</h3>
                        <p className={styles.footerLink}>
                            Grind
                            <br />
                            8-10 New North Place
                            <br />
                            London EC2A 4JA
                            <br />
                            United Kingdom
                        </p>
                    </div>

                    <div>
                        <h3 className={cx(styles.heading)}>Contact us.</h3>
                        <a
                            className={cx(styles.footerLink)}
                            href="mailto:shop@grind.co.uk"
                        >
                            shop@grind.co.uk
                        </a>

                        <h3 className={cx(styles.heading)}>Legal stuff.</h3>

                        <a
                            className={cx(styles.footerLink)}
                            href="https://grind.co.uk/pages/privacy"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Privacy Policy
                        </a>

                        <a
                            className={cx(styles.footerLink)}
                            href="https://grind.co.uk/pages/terms"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Terms &amp; Conditions
                        </a>
                    </div>

                    <div>
                        <h3 className={cx(styles.heading)}>Need help?</h3>
                        <a
                            className={cx(styles.footerLink)}
                            href="https://intercom-help.eu/grind--co/en"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Take a look at our help centre.
                        </a>

                        <a
                            className={cx(styles.footerLink)}
                            href="mailto:shop@grind.co.uk"
                        >
                            Something else? Get in touch at{" "}
                            <strong>shop@grind.co.uk</strong>
                        </a>
                    </div>

                    <div>
                        <p className={styles.paymentOptions}>
                            {paymentOptions.map((paymentOption) => (
                                <img
                                    src={paymentOption.img}
                                    alt={paymentOption.alt}
                                    key={paymentOption.alt}
                                    width={60}
                                    height={40}
                                />
                            ))}
                        </p>
                        <p className={cx(styles.copyright)}>
                            Copyright © {new Date().getFullYear()}, Grind.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
